import script from "./PrintButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PrintButton.vue?vue&type=script&setup=true&lang=js"

import "./PrintButton.vue?vue&type=style&index=0&id=5a417731&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a417731"]])

export default __exports__